<template>

  <div v-if="controls" class="job-status-filter field is-horizontal">
    <div class="field-label is-normal">
      <label class="label" :for="id">Status</label>
    </div>
    <div class="field-body">
      <div class="field is-narrow">
        <div class="control">
          <div class="select">
            <select :id="id" :value="selected" @change="handleChange">
              <option :value="ANY">{{ anyLabel }}</option>
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

  import constants from '~/lib/domain/constants';
  import lang from '~/lib/lang';
  import uuid from '~/lib/uuid';

  /**
   * The empty selection. A <select> option cannot carry an empty value and
   * still round-trip through the DOM as one, so "any status" gets a sentinel
   * that never collides with a real state name.
   */
  const ANY = '';

  export default {

    name: 'job-status-filter',

    props: {

      /**
       * The currently selected status value, or '' for no filter.
       */
      selected: {
        type: String,
        required: false,
        default: ANY,
      },

      /**
       * Whether to render the control at all. A page that never wants status
       * filtering passes false rather than wrapping the component in its own
       * v-if, so the decision lives at the call site.
       */
      controls: {
        type: Boolean,
        required: false,
        default: true,
      },

      /**
       * Label for the unfiltered option.
       */
      anyLabel: {
        type: String,
        required: false,
        default: 'All statuses',
      },
    },

    data () {
      return {
        ANY,
        id: `job-status-filter-${uuid.v4()}`,
      };
    },

    computed: {

      /**
       * Statuses in workflow order -- open through closed -- because that is
       * the order the office thinks in. JOB_STATES declares them that way.
       */
      options () {
        return lang.collection.map(constants.JOB_STATES, (label, value) => {
          return {label, value};
        });
      },
    },

    methods: {

      handleChange (event) {
        this.$emit('change', event.target.value);
      },
    },
  };

</script>
<style lang="scss" scoped>

  .job-status-filter {
    margin-bottom: 0.75rem;

    .field-label {
      flex-grow: 0;
      margin-right: 0.75rem;
    }
  }

</style>
